import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { AddIcon, FileIcon } from "../../Assets/assets";
import BreadCrumbs from "../../Components/BreadCrumbs/BreadCrumbs";
import Button from "../../Components/Button/Button";
import CustomSelect from "../../Components/CustomSelect/CustomSelect";
import MultipleSelect from "../../Components/Filters/MultipleSelect";
import InputBox from "../../Components/InputBox/InputBox";
import Modal from "../../Components/Modal/Modal";
import Table from "../../Components/Table/Table";
import { useResizeObserver } from "../../CustomHooks/useResizeObserver";
import { uploadReport } from "../../Redux/reports/action";
import { setErrorStatus } from "../../Redux/status/action";
import {
  setSelectedTableData,
  setTableFilter,
  setTablePageNumber,
  setTableSearchKey,
  setTableSort
} from "../../Redux/table/action";
import { getFileUrl } from "../../Services/storage";
import { isValidObject } from "../../Services/validators";
import {
  downloadBlobFile,
  FilterSeparator,
  isFilterApplied
} from "../../Utils/Constants/Constants";
import {
  convertToTableData,
  defaultReportFilter,
  reportsFilterData,
  reportsTableField,
  reportsTableHeadings
} from "../../Utils/Constants/Reports";
import SingleSelect from "../../Components/Filters/SingleSelect";
import { exportFiles } from "../../Services/api";

export const Reports = (props) => {
  const [selectedFilters, setSelectedFilters] = useState(defaultReportFilter);
  const [collapse, setCollapse] = useState(true);
  const tableContainerRef = useRef(null);
  const filterContainerRef = useRef(null);
  const { height } = useResizeObserver(filterContainerRef);
  const [isResetSingleKey, setIsResetSingleKey] = useState(false);
  const [report, setReport] = useState(null);
  const [downloadReportLoading, setDownloadReportLoading] = useState(false);
  const [reportFormData, setReportFormData] = useState({
    type: null,
    name: "",
    to: null,
    from: null
  });

  useEffect(() => {
    if (!isResetSingleKey) {
      setSelectedFilters(props.table.reports.filter);
    }
  }, [props.table.reports.filter, isResetSingleKey]);

  const handleApplyClick = () => {
    props.setTableFilter("REPORTS", selectedFilters);
  };

  const handleResetClick = (key) => {
    setIsResetSingleKey(true);
    setSelectedFilters({
      ...selectedFilters,
      [key]: defaultReportFilter[key]
    });
    props.setTableFilter("REPORTS", {
      ...props.table.reports.filter,
      [key]: defaultReportFilter[key]
    });
  };

  const handleClearClick = () => {
    props.setTableFilter("REPORTS", defaultReportFilter);
    props.setTableSearchKey("REPORTS", "");
    setSelectedFilters(defaultReportFilter);
  };

  const handleDisableFilter = () => {
    return window.location.pathname.split("/")[3] ? true : false;
  };

  const formSubmitDisable = () => {
    if (report !== null && reportFormData.type !== null) {
      if (
        reportFormData.type !== "Custom" &&
        reportFormData.to !== null &&
        reportFormData.from !== null
      ) {
        return false;
      } else if (
        reportFormData.type === "Custom" &&
        reportFormData.name?.length > 0 &&
        reportFormData.from !== null &&
        reportFormData.to !== null
      ) {
        return false;
      }
    }
    return true;
  };

  const handleDownloadReport = async (loading, report) => {
    if (loading) {
      setErrorStatus({
        code: "custom",
        message: "Download in progress. Try again once it finishes."
      });
      return;
    }
    if(!isValidObject(report)){
      setErrorStatus({
        code: "custom",
        message: "Invalid document"
      });
      return;
    }
    try {
      setDownloadReportLoading(report.documentId);
      if (report.documentId === "kpiReport") {
        const blob = await exportFiles(
          props.auth.data.accessToken,
          [
            "createdAt", ">=", report.info?.period?.from,
            "createdAt", "<=", report.info?.period?.to
          ],
          "kpisummary"
        );
        downloadBlobFile(blob, report.fileName);
      } else {
        const file = await getFileUrl(report.asset);
        const fileUrl = typeof file === "string" ? file : file.url;
        window.open(fileUrl, "_blank");
      }
    } catch (error) {
      setErrorStatus(error);
    } finally {
      setDownloadReportLoading(false);
    }
  };

  useEffect(() => {
    props.setTablePageNumber("REPORTS", 1);
    // eslint-disable-next-line
  }, [props.table.reports.filter]);

  return (
    <>
      <div
        className="inherit-parent-height inherit-parent-width position-relative overflow-hidden"
        ref={tableContainerRef}
      >
        <div className="inherit-parent-width">
          <div className="display-flex flex-justify-content-space-between flex-align-items-center">
            <BreadCrumbs />
            {props.claims?.files?.create === true ? (
              <div className="padding-right-default">
                <form
                  onChange={(event) => {
                    if (event.target.files) {
                      setReport(event.target.files[0]);
                    }
                  }}
                >
                  <label
                    className=" display-flex flex-align-items-center"
                    style={{ width: "145px" }}
                  >
                    {props.reports.uploadLoading ? (
                      <></>
                    ) : (
                      <input
                        type="file"
                        // accept=".xls,.xlsx"
                        data-cy="UPLOAD-REPORT-BUTTON"
                        name="fileUploaderInput"
                        onClick={(event) => {
                          event.target.value = "";
                        }}
                        className="visibility-hidden position-absolute"
                      />
                    )}

                    <div
                      data-cy="UPLOAD-NEW-REPORT-BUTTON"
                      className=" inherit-parent-width display-flex flex-align-items-center flex-justify-content-center font-size-small cursor-pointer"
                      style={{
                        background: "var(--secondaryColor)",
                        color:
                          props.auth.theme.primaryColor === "#0E0E0E"
                            ? "#0E0E0E"
                            : "#FFFFFF",
                        height: "32px",
                        fontWeight: "700"
                      }}
                    >
                      {props.reports.uploadLoading ? (
                        <div className="flex-place-children-page-center padding-vertical-small margin-top-smaller">
                          <div
                            className={`${
                              props.disabled
                                ? "dot-pulse-dark"
                                : props.variant === "primaryBorder"
                                ? "dot-pulse-primary"
                                : "dot-pulse"
                            }`}
                          />
                        </div>
                      ) : (
                        <>
                          <AddIcon
                            color={
                              props.auth.theme.primaryColor === "#0E0E0E"
                                ? "#0E0E0E"
                                : "#FFFFFF"
                            }
                          />
                          <div className=" padding-left-default">
                            Upload Report
                          </div>
                        </>
                      )}
                    </div>
                  </label>
                </form>
              </div>
            ) : (
              <></>
            )}
          </div>

          <div
            ref={filterContainerRef}
            className="padding-top-larger display-flex flex-justify-content-space-between"
          >
            <div
              style={{ width: "90%", flexWrap: "wrap", gap: "8px" }}
              className="display-flex flex-align-items-center"
            >
              {/* <div>
                    <SearchBox
                      title="SEARCH PROCEDURE"
                      placeHolder="SEARCH PROCEDURE"
                      value={props.table.reports.searchKey}
                      onChange={(event) => {
                        props.setTableSearchKey("REPORTS", event.target.value);
                      }}
                      showCloseIcon={true}
                      closeOnClick={() => {
                        if (props.table.reports.searchKey.length > 0) {
                          props.setTableSearchKey("REPORTS", "");
                        }
                      }}
                    />
                  </div>
    
                  <FilterSeparator /> */}
              <div className="display-flex flex-align-items-center position-relative">
                <SingleSelect
                  disabled={handleDisableFilter()}
                  loading={props.reports.loading}
                  data-cy="MONTH-SINGLE"
                  data={reportsFilterData()[0]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  array={true}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.reports.filter}
                  selected={selectedFilters["month"]}
                />
                <FilterSeparator />
                <SingleSelect
                  disabled={handleDisableFilter()}
                  loading={props.reports.loading}
                  data-cy="YEAR-SINGLE"
                  data={reportsFilterData()[1]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  array={true}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.reports.filter}
                  selected={selectedFilters["year"]}
                />
                <FilterSeparator />
                <MultipleSelect
                  disabled={handleDisableFilter()}
                  loading={props.reports.loading}
                  data-cy="REPORT-TYPE-MULTI"
                  data={reportsFilterData()[2]}
                  onResetClick={(key) => {
                    handleResetClick(key);
                  }}
                  setSelectedFilters={setSelectedFilters}
                  selectedFilters={selectedFilters}
                  appliedFilters={props.table.reports.filter}
                  selected={selectedFilters["reportType"]}
                />
              </div>
            </div>

            {isFilterApplied(selectedFilters, "REPORTS")?.validation && (
              <div
                style={{
                  width: "10%"
                }}
                className={`display-flex flex-justify-content-space-between`}
              >
                <div
                  style={{
                    width: "60%"
                  }}
                >
                  <Button
                    data-cy="FILTER-APPLY-BUTTON"
                    text="Apply"
                    boxShadow={false}
                    variant="filter"
                    loading={props.loading}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleApplyClick();
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "40%"
                  }}
                >
                  <Button
                    data-cy="FILTER-RESET-BUTTON"
                    variant="transparent"
                    text="Clear"
                    boxShadow={false}
                    className="inherit-parent-width padding-left-large padding-right-large"
                    onClick={() => {
                      handleClearClick();
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            height: `calc(100% - ${height + 32}px`
          }}
        >
          {/* {!collapse && (
                <>
                  <div className="display-flex flex-justify-content-space-between margin-top-larger">
                    {InfoCardData.map((data, index) => (
                      <div key={index} style={{ width: "calc(100% / 3 - 20px)" }}>
                        <InfoCard data={data} />
                      </div>
                    ))}
                  </div>
                  <div className="display-flex flex-justify-content-space-between padding-top-larger ">
                    <GraphCard
                      title="OPERATION LOCATIONS"
                      graph={<DoughnutChart data={sampleDoughnutChartData} />}
                      legend={
                        <div className="display-flex flex-justify-content-center padding-top-large">
                          {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                            (data, i) => (
                              <div key={i}>
                                <LegendCard
                                  data={sampleDoughnutChartData}
                                  color={data}
                                  index={i}
                                />
                              </div>
                            )
                          )}
                        </div>
                      }
                    />
                    <GraphCard
                      title="OPERATION LOCATIONS"
                      graph={<DoughnutChart data={sampleDoughnutChartData} />}
                      legend={
                        <div className="display-flex flex-justify-content-center padding-top-large">
                          {sampleDoughnutChartData.datasets[0].backgroundColor.map(
                            (data, i) => (
                              <div key={i}>
                                <LegendCard
                                  data={sampleDoughnutChartData}
                                  color={data}
                                  index={i}
                                />
                              </div>
                            )
                          )}
                        </div>
                      }
                    />
                    <GraphCard
                      title="OPERATION LOCATIONS"
                      type="line"
                      graph={<LineChart data={sampleBarChartData} />}
                      legend={
                        <div
                          style={{
                            paddingTop: "31px"
                          }}
                        />
                      }
                    />
                  </div>
                </>
              )} */}

          {height && (
            <div
              style={{
                height: `calc(100% - ${collapse ? 0 : 420}px`
              }}
              className="padding-top-larger"
            >
              <Table
                title="ALL REPORTS"
                setCollapse={(data) => {
                  setCollapse(data);
                  if (tableContainerRef.current) {
                    tableContainerRef.current.scrollTop = 0;
                  }
                }}
                allowCollapse={false}
                collapse={collapse}
                headers={reportsTableHeadings}
                onClick={(data) => {
                  handleDownloadReport(downloadReportLoading, data);
                }}
                data={
                  isValidObject(props.reports.data)
                    ? convertToTableData(
                        Object.values(props.reports.data),
                        downloadReportLoading
                      ).slice(
                        !collapse
                          ? 0
                          : (props.table.reports.pageNumber - 1) * 50,
                        !collapse ? 6 : props.table.reports.pageNumber * 50
                      )
                    : []
                }
                getField={reportsTableField}
                totalPage={
                  isValidObject(props.reports.data)
                    ? Math.ceil(
                        Object.values(props.reports.data).length / 50
                      ) || 1
                    : 1
                }
                currentPage={props.table.reports.pageNumber}
                previousPageOnClick={() => {
                  props.setTablePageNumber(
                    "REPORTS",
                    props.table.reports.pageNumber - 1
                  );
                }}
                nextPageOnClick={() => {
                  props.setTablePageNumber(
                    "REPORTS",
                    props.table.reports.pageNumber + 1
                  );
                }}
                resetAllClick={() => {
                  handleClearClick();
                }}
                sort={props.table.reports.sort}
                handleSort={(title) => {
                  props.setTablePageNumber("REPORTS", 1);
                  props.setTableSort("REPORTS", {
                    title: title,
                    ascending:
                      props.table?.reports?.sort?.title === title
                        ? !props.table?.reports?.sort?.ascending
                        : true
                  });
                }}
                backgroundColor="background-color-primary"
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        show={report ? true : false}
        // canIgnore={true}
        // onClose={() => {
        //   setReport(null);
        //   setReportFormData({
        //     type: null,
        //     name: "",
        //     to: null,
        //     from: null
        //   });
        // }}
        width=" width-400px"
        minWidth="width-400px"
        // maxHeight="max-height-90-percentage"
        background="background-color-tertiaryColor2"
        boxShadow="true"
        borderRadius="false"
        height="height-fit-content"
      >
        <div
          className="padding-larger display-flex flex-direction-column flex-align-items-center flex-justify-content-center "
          style={{ color: "var(--tertiaryColor)" }}
          data-cy="UPLOAD-REPORT-MODAL"
        >
          <div className=" font-size-larger font-family-RHD-medium text-align-center">
            Upload document
          </div>
          <div className=" font-size-medium padding-top-default text-align-center">
            Select document type and required information
          </div>

          <div
            className=" padding-large margin-vertical-large text-align-left font-size-small inherit-parent-width display-flex flex-align-items-center"
            style={{
              background:
                props.auth.theme.primaryColor === "#0E0E0E"
                  ? "#263329"
                  : "#DBF6E3"
            }}
          >
            <FileIcon
              color={
                props.auth.theme.primaryColor === "#0E0E0E"
                  ? "#CFCFCF"
                  : "#353535"
              }
            />
            <div
              className=" padding-left-default"
              style={{ width: "calc(100% - 20px)" }}
            >
              {report?.name}
            </div>
          </div>

          <CustomSelect
            data-cy="REPORT-DOCUMENT-TYPE"
            options={[
              { title: "Payslip", key: "Payslip" },
              { title: "Provident fund", key: "Provident fund" },
              {
                title: "Employees state Insurance",
                key: "Employees state insurance"
              },
              { title: "Custom", key: "Custom" }
            ]}
            placeholder={reportFormData?.type || `DOCUMENT TYPE`}
            handleSelectedData={(data) => {
              setReportFormData({
                ...reportFormData,
                type: data
              });
            }}
            search={false}
            selected={reportFormData.type}
            removeResponsive={true}
            label="DOCUMENT TYPE"
            value={reportFormData?.type}
            fontColor="font-color-tertiaryColor"
            labelFontColor="font-color-tertiaryColor"
          />

          {reportFormData.type === "Custom" && (
            <InputBox
              className="inherit-parent-width margin-top-default"
              name="Name"
              label="DOCUMENT NAME"
              type="text"
              placeholder="Name"
              removeResponsive={true}
              value={reportFormData.name}
              onChange={(event) => {
                setReportFormData({
                  ...reportFormData,
                  name: event.target.value
                });
              }}
              fontColor="font-color-tertiaryColor"
              labelFontColor="font-color-tertiaryColor"
              data-cy="REPORT-DOCUMENT-NAME"
              // required
            />
          )}

          <div
            className="display-flex inherit-parent-width padding-top-default"
            style={{ gap: "0" }}
          >
            {["FROM", "TO"].map((label, i) => (
              <div
                key={label}
                style={{
                  width: "50%",
                  marginRight: i === 0 ? "16px" : "0"
                }}
                className="date-container"
              >
                <div className="padding-top-large font-size-smaller">
                  {label}
                </div>
                <input
                  style={{
                    width: "100%",
                    border: "none",
                    backgroundColor: "transparent",
                    paddingBottom: "10px"
                  }}
                  type="date"
                  data-cy={`REPORT-${label}-FIELD`}
                  value={reportFormData?.[label.toLowerCase()] || ""}
                  onChange={(e) => {
                    setReportFormData({
                      ...reportFormData,
                      [label.toLowerCase()]: e.target.value
                    });
                  }}
                />
              </div>
            ))}
          </div>

          <div className=" padding-top-larger display-flex inherit-parent-width ">
            <Button
              type="button"
              data-cy={`UPLOAD-REPORT-SUBMIT-BUTTON${
                props.reports.uploadLoading ? "-LOADING" : ""
              }`}
              text="Upload"
              boxShadow={false}
              loading={props.reports.uploadLoading}
              className=" padding-left-larger padding-right-larger "
              disabled={formSubmitDisable()}
              onClick={() => {
                props.uploadReport({ ...reportFormData, file: report });
                setReport(null);
                setReportFormData({
                  type: null,
                  from: null,
                  to: null
                });
              }}
            />

            <Button
              data-cy={`UPLOAD-REPORT-CANCEL-BUTTON${
                props.reports.uploadLoading ? "-LOADING" : ""
              }`}
              text="Cancel"
              boxShadow={false}
              variant="transparent"
              loading={props.reports.uploadLoading}
              className=" padding-left-larger padding-right-larger"
              onClick={() => {
                setReport(null);
                setReportFormData({
                  type: null,
                  period: null,
                  year: null
                });
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = function(state) {
  return {
    auth: state.auth,
    locations: state.locations,
    table: state.table,
    reports: state.reports,
    workforce: state.workforce
  };
};

const mapDispatchToProps = function() {
  return {
    setSelectedTableData: (tableName, data) =>
      setSelectedTableData(tableName, data),
    setTableFilter: (tableName, data) => setTableFilter(tableName, data),
    setTableSort: (tableName, data) => setTableSort(tableName, data),
    setTableSearchKey: (tableName, value) =>
      setTableSearchKey(tableName, value),
    setTablePageNumber: (tableName, value) =>
      setTablePageNumber(tableName, value),
    uploadReport: (data) => uploadReport(data)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
